import $ from 'jquery';

export default function clipboard() {
    return (
        $('.btn-copy').on('click', function (event) {
            var el = $(event.target);
            var target_id = el.attr('data-clipboard-target');
            var code = document.querySelector(target_id);
            var range = document.createRange();
            range.selectNodeContents(code);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            navigator.clipboard.writeText(document.querySelector(target_id).innerText.trim());
            el.addClass('bg-success').removeClass('bg-blue').html('کپی شد');
            setTimeout(function () {
                el.addClass('bg-blue').removeClass('bg-success').html('کپی کنید');
            }, 1000);

            if (el.data('trackable') === 'true' || el.data('trackable') === true) {
                var data = {
                    'title': el.data('title'),
                    'coupon_id': el.data('coupon-id'),
                    'brand_name': el.data('brand-name'),
                    'action': "کلیک روی دکمه کپی"
                };
            }
        })
    );
};


// WEBPACK FOOTER //
// ./src/containers/Coupons/clipboard.js